
import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  FiCalendar,
  FiMonitor,
  FiUsers,
  FiCheckSquare,
  FiDollarSign,
  FiTrendingUp,
  FiUserPlus,
  FiUser
} from "react-icons/fi";
import { Link } from "react-router-dom";

const cards = [
  {
    title: "Attendance Overview",
    value: "120/154",
    link: "View Details",
    icon: <FiCalendar />,
    color: "orange"
  },
  {
    title: "Total No of Project's",
    value: "90/125",
    link: "View All",
    icon: <FiMonitor />,
    color: "teal"
  },
  {
    title: "Total No of Clients",
    value: "69/86",
    link: "View All",
    icon: <FiUsers />,
    color: "blue"
  },
  {
    title: "Total No of Tasks",
    value: "96/100",
    link: "View All",
    icon: <FiCheckSquare />,
    color: "pink"
  },
  {
    title: "Earnings",
    value: "$21,445",
    link: "View All",
    icon: <FiDollarSign />,
    color: "purple"
  },
  {
    title: "Profit This Week",
    value: "$5,544",
    link: "View All",
    icon: <FiTrendingUp />,
    color: "red"
  },
  {
    title: "Job Applicants",
    value: "98",
    link: "View All",
    icon: <FiUserPlus />,
    color: "green"
  },
  {
    title: "New Hire",
    value: "45/48",
    link: "View All",
    icon: <FiUser />,
    color: "dark"
  }
];

export default function EmployeesDashboardCards() {
  return (
    <>
      <Row className="g-3">
        {cards.map((card, index) => (
          <Col xs={6} md={6} xl={3} key={index}>
            <Card className="dashboard-card">
              <Card.Body>
                <div className={`icon-circle ${card.color}`}>
                  {card.icon}
                </div>

                <h6 className="card-title">{card.title}</h6>

                <h3 className="card-value">{card.value}</h3>

                <Link to="/" className="btn btn border">
                  {card.link}
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <style>
        {`
        .dashboard-card{
          border-radius:6px;
          border:1px solid #e5e7eb;
          background:#ffffff;
          box-shadow:0 2px 5px rgba(0,0,0,0.05);
          padding:5px;
          height:100%;
        }

        .dashboard-card .card-body{
          padding:15px;
        }

        .icon-circle{
          width:40px;
          height:40px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          color:white;
          font-size:20px;
          margin-bottom:14px;
        }

        .orange{background:#f26522;}
        .teal{background:#0d5c63;}
        .blue{background:#2f80ed;}
        .pink{background:#ff3f7f;}
        .purple{background:#8e44ad;}
        .red{background:#ff0000;}
        .green{background:#1db954;}
        .dark{background:#222;}

        .card-title{
          font-size:14px;
          font-weight:500;
          color:#6c757d;
          margin-bottom:4px;
        }

        .card-value{
          font-size:24px;
          font-weight:700;
          color:#1f2d3d;
          margin-bottom:10px;
        }

        .view-link{
          font-size:14px;
          color:#6c757d;
          text-decoration:none;
        }

        .view-link:hover{
          color:#000;
        }

        /* Mobile Responsive */
        @media (max-width: 576px) {
          .card-title{
            font-size:12px;
          }

          .card-value{
            font-size:18px;
          }

          .dashboard-card .card-body{
            padding:12px;
          }

          .icon-circle{
            width:35px;
            height:35px;
            font-size:18px;
            margin-bottom:10px;
          }

          .btn{
            font-size:12px;
            padding:4px 8px;
          }
        }
        `}
      </style>
    </>
  );
}

